import styled from 'styled-components';
import media from '../styles/media';


const StyledMovieCartWrapper = styled.div`
    h5, h6 {
        color: ${props => props.theme.cmPlum};
    }

    span.user-name {
        color: #582C83; 
        text-transform: capitalize;
        font-weight: 500;

    }

    .card-header {
        display: flex;
        justify-content: space-between;
    }

    table {
        table-layout: fixed;
    }

    table td {
        padding: 0.75rem 0.5rem;
    }

    .title {
        width: 13%;
        white-space: normal;
    }

    .title-button {
        text-align: left;

        &:hover {
            color: #582C83;
        }
    }

    .image {
        width: 14%;
    }

    .screening-table.image {
        width: 11%;
    }

    .hover-curser {

        &:hover{
            cursor: pointer;
        }
    }

    .req-result, .appr-result, .expir-result {
        color: #5a5a65;
    }

    .appr-result {
       word-wrap: normal;

    }

    .req-result, .expir-result {
        white-space: nowrap;
    }

    .desc {
        white-space: normal;
    }

    td, th {
        text-align: center;
        display: table-cell;
        vertical-align: inherit;
    }

    tr {
        &:first-child {
            border-top: none;
        }

        &:hover {
            background: #e0e1e2de;
        }
    }

    th {
        background-color: #582C83;
        color: white;
    }

    .header {
        vertical-align: middle;
        word-wrap: normal;
        text-align: center;
    }

    tbody:nth-child(odd) {
        background: #f4f4f5;
    }

    .container {
        padding: 40px 15px;
    }

    img { 
        width: 100px;
    }

    button {
        border: 0;
        background: #fff0;
    }

    .fas, .far {
        color: ${props => props.theme.cmPlum};
        font-size: 18px;
        text-align: center;
    }

    .synopsis-content, .title-content {
        text-align: left;
    }

    .desc-click {
        display: -webkit-box;
        -webkit-line-clamp: 3;
        -webkit-box-orient: vertical;
        overflow: hidden;
        text-overflow: ellipsis;

    }


    ${media.mobileS`
        h3 {
            font-size: 1rem;
        }

        .container {
            padding: 10px 0;
        }

        .card-header {
            font-size: 13px;
        }

        .card-body {
            padding: 0;
        }

        .header {
            font-size: 9px;
            padding: 0.75rem 0.1rem;
        }

        img {
            width: 37px;
            height: auto;
        }

        .desc {
            width: 33%;
        }

        td.desc.standard {
            text-align: left;
            font-size: 0.8rem;
        }

        .standard {
            font-size: 9px;
            padding: 0.75rem .1rem;
        }

        .button {
            font-size: 9px;
            padding: 0.75px 0.1rem;
            /* box-shadow: 0 2px 5px 0 rgba(0,0,0,0.16), 0 2px 10px 0 rgba(0,0,0,0.12);
            background-color 0.15s ease-in-out;
            box-shadow 0.15s ease-in-out; */
        }

        .action {
            display: flex;
            justify-content: space-around;
            text-align: center;
            display: table-cell;
            vertical-align: inherit;

        }

        th.delete.header {
            width: 10%;
        }

        .fas {
            font-size: 0.8rem;
        }

        .far {
            font-size: 0.8rem;
        }

        .title-click {
            text-align: left;
        }



    `}

    ${media.tablet`
        h3 {
            font-size: 1.4rem;
        }
        
        .card-header {
            font-size: 1rem;
        }

        .card-body {
            padding: 0.75rem 0.5rem;
        }

        .header {
            font-size: 0.8rem;
        }

        img {
            width: 58px;
        }

        .desc {
            width: 38%;
        }

        .standard {
            font-size: 0.8rem;
            padding: 0.75rem 0.5rem;
        }

        .fas {
            font-size: 0.8rem;
        }

        .far {
            font-size: 1.5rem;
        }

    `}

    ${media.tabletL`
        h3 {
            font-size: 1.8rem;
        }

        .container {
            padding: 40px 15px;
        }

        .card-header {
            font-size: 1.3rem;
        }

        .card-body {
            padding: 1.25rem;
        }

        .header {
            font-size: 0.8rem;
            padding: 0.75rem 0.5rem;
        }

        .standard {
            font-size: 0.8rem;
            padding: 0.75rem 0.5rem;
        }

        img {
            width: 81px; 
        }

        .desc {
            width: 42%;
        }

        .image-screen {
            width: 11%;
        }
        
        .desc .standard {
            text-align: left;
        }

        .fas {
            font-size: 0.8rem;
        }
    `}

    ${media.laptop`
        img {
            width: 100px;
        }
    `}


`

export default StyledMovieCartWrapper;